export const workflowInstanceStatus = {
  NotStarted: 1,
  InProgress: 2,
  Complete: 3,
  Cancelled: 4
}

export const WORKFLOW_INSTANCE_STATUS_OPTIONS = [
  { id: workflowInstanceStatus.NotStarted, name: 'Not Started' },
  { id: workflowInstanceStatus.InProgress, name: 'In Progress' },
  { id: workflowInstanceStatus.Complete, name: 'Complete' },
  { id: workflowInstanceStatus.Cancelled, name: 'Cancelled' }
]

export const workflowTaskStatus = {
  NotStarted: 1,
  InProgress: 2,
  Done: 3,
  OffTrack: 4,
  Blocked: 5,
  Cancelled: 6
}

export const WORKFLOW_TASK_STATUS_OPTIONS = [
  { id: workflowTaskStatus.NotStarted, name: 'Not Started' },
  { id: workflowTaskStatus.InProgress, name: 'In Progress' },
  { id: workflowTaskStatus.Done, name: 'Done' },
  { id: workflowTaskStatus.OffTrack, name: 'Off-Track' },
  { id: workflowTaskStatus.Blocked, name: 'Blocked' },
  { id: workflowTaskStatus.Cancelled, name: 'Cancelled' }
]
